import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
/* Hard-refresh resilience: on first mount, the in-memory access token
 * is empty even though the HttpOnly refresh cookie is still on disk.
 * Try the refresh endpoint once before kicking the user out, so an F5
 * stays signed in. The idle timer (useIdleTimeout) handles the
 * "log out after no activity" case independently.
 */
export function ProtectedRoute() {
    const token = useAuthStore((s) => s.accessToken);
    const refresh = useAuthStore((s) => s.refresh);
    const location = useLocation();
    const [bootstrapping, setBootstrapping] = useState(!token);
    useEffect(() => {
        if (token || !bootstrapping)
            return;
        let cancelled = false;
        refresh().finally(() => {
            if (!cancelled)
                setBootstrapping(false);
        });
        return () => { cancelled = true; };
    }, [token, bootstrapping, refresh]);
    if (bootstrapping) {
        return (_jsx("div", { className: "flex min-h-screen items-center justify-center text-sm text-muted-foreground", children: "Restoring your session\u2026" }));
    }
    if (!token) {
        return _jsx(Navigate, { to: "/login", replace: true, state: { from: location } });
    }
    return _jsx(Outlet, {});
}
